import { render, staticRenderFns } from "./ApiTable.vue?vue&type=template&id=4a805da8"
import script from "./ApiTable.vue?vue&type=script&lang=js"
export * from "./ApiTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports